<template>
	
  <div :class="['py-5 px-3', 'bk-'+ section]" id="box-docs">
    <div class="container-fluid py-2 py-lg-4">

      <h2 class="text-center mb-4">
        Documents
      </h2>

      <div v-for="(docType, typeName) in this.pageItem.docs" :key="typeName">

        <div class="row text-center justify-content-center" v-if="docType.length">

            <h3 class="mt-5 mb-4">
                {{ getTitle(typeName) }}
            </h3>

            <div v-if="docType.length <= 4">
              <div class="col-12 col-lg-auto" v-for="(doc, indexDoc) in docType" :key="indexDoc">
                  <a class="btn btn-download outline my-3 my-lg-4" :href="doc.src" @click="launchPdf">
                      {{ doc.title }}
                  </a>
              </div>
            </div>

            <div v-if="docType.length > 4" class="btn-group-vertical">
              <div class="my-3" v-for="(doc, indexDoc) in docType" :key="indexDoc">
                  <a class="btn btn-download outline" :href="doc.src" @click="launchPdf">
                      {{ doc.title }}
                  </a>
              </div>
            </div>

        </div>

      </div>
      
    </div>
  </div>

</template>

<script>
    export default {
		name: 'YachtDocuments',
		props: ['section', 'pageItem'],
		data () {
      return {
        publicPath: process.env.BASE_URL
      }
		},
		computed: {
		},
		methods: {
      getTitle(typeName) {
        let title = typeName
        switch(typeName) {
          case 'arrangements':
            title = "General arrangements"
            break;
          case 'others':
            title = "Other documents"
            break;
          case 'plans':
            title = "Functional plans"
            break;
        }
        return title
      },
      launchPdf(ev) {
        this.$store.dispatch('launchPdf', ev)
      },
		},
	}
</script>

<style scoped>
.maiora h3 {
  text-transform: capitalize;
}
.btn-group-vertical {
  align-items: center;
}
</style>
